/* eslint-disable no-restricted-imports */
import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  RadioGroup,
  Radio,
  MenuItem,
  Select,
  FormControlLabel
} from "@material-ui/core";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { Spinner } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";

export function RestorePage() {
  const RESTORE_UPLOAD_URL =
    "http://49.50.164.105:8089/ucworks-email-mass/restore_upload.do";

  const useStyles = makeStyles(theme => ({
    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    labelStyle: {
      display: "inline-block",
      marginTop: "-2px",
      fontSize: "1.2rem",
      width: "120px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    selectStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      background: "transparent",
      marginRight: "12px",
      borderRadius: "4px 4px 4px 4px",
      ":active": {
        background: "transparent"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1.2rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleLastStyle: {
      fontSize: "1rem",
      //   fontWeight: "bold",
      color: "#555555",
      marginTop: "-8px"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "50%",
      height: "44px"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const Styles = useStyles();

  const inputFileRef = useRef(null);
  const [refresh, setRefresh] = React.useState(false);
  const [logLevel, setLogLevel] = React.useState("DOMAIN");
  const [uploadFile, setUploadFile] = React.useState();

  const [showAsk, setShowAsk] = React.useState(false);
  const [showNew, setShowNew] = React.useState(false);
  const [editTitle, setEditTitle] = React.useState("");
  const [filePath, setFilePath] = React.useState("");
  const [editDesc, setEditDesc] = React.useState("");
  const [loading, setLoading] = useState(false);

  const uploadMassX = async () => {

    if(filePath.length === 0) return;
    
    const formData = new FormData();
    formData.append("file1", uploadFile[0]);

    setLoading(true);

    try {
      const uploadResult = await fetch(RESTORE_UPLOAD_URL, {
        method: "POST",
        body: formData
      });
      console.log("UploadResult", uploadResult);

      if (uploadResult.status === 200) {
        setFilePath('');
        toast("업로드 되었습니다.\n메일 엔진을 재기동해야 적용됩니다.");
      } else {
        toast("서버 에러가 발생했습니다 : " + uploadResult.status);
      }
    } catch (err) {
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  const checkIpAddress = () => {
    return true;
  };

  const handleChangeLogLevel = event => {
    setLogLevel(event.target.value);
  };

  useEffect(() => {}, [editTitle, filePath, editDesc, refresh, loading]);

  return (
    <>
      {loading ? (
        <div style={{ width: "100%", height: "100%" }}>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{ margin: "40% 50% 30% 50%", width: "24px", height: "24px" }}
          />
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <div>
          <ToastContainer />
          <div
            style={{
              marginTop: "12px",
              marginLeft: "-12px",
              height: "100%"
            }}
          >
            {/* -------------------- */}

            <div className={Styles.boxContainer}>
              <div className={Styles.boxStyle}>
                <div className={Styles.subTitleStyle}>
                  <Button
                    // className={Styles.buttonStyle}
                    className={[
                      Styles.buttonStyle,
                      filePath.length === 0 && Styles.buttonDisableStyle
                    ]}

                    onClick={() => {
                      uploadMassX();
                    }}
                  >
                    저장
                  </Button>
                </div>

                <div className={Styles.subTitleLastStyle}>
                  {/* <InputLabel htmlFor="age-simple">메일백업 / PC에 저장</InputLabel> */}
                  <div className={Styles.labelStyle}>복구 대상</div>
                  <RadioGroup
                    aria-label="방향"
                    name="gender1"
                    style={{
                      display: "inline-block",
                      fontSize: "1.2rem"
                    }}
                    // className={classes4.group}
                    value={logLevel}
                    onChange={handleChangeLogLevel}
                  >
                    <FormControlLabel
                      value="DOMAIN"
                      style={{
                        marginTop: "4px",
                        marginRight: "12px",
                        fontSize: "1.2rem"
                      }}
                      control={<Radio />}
                      label="도메인 및 계정정보"
                    />
                    <FormControlLabel
                      value="CONFIG"
                      style={{ marginTop: "4px", fontSize: "1.2rem" }}
                      control={<Radio />}
                      label="환경설정"
                    />
                    <FormControlLabel
                      value="STATS"
                      style={{ marginTop: "4px", fontSize: "1.2rem" }}
                      control={<Radio />}
                      label="통계"
                    />
                    <FormControlLabel
                      value="LOGS"
                      style={{ marginTop: "4px", fontSize: "1.2rem" }}
                      control={<Radio />}
                      label="로그"
                    />
                  </RadioGroup>
                </div>

                <div
                  className={Styles.subTitleLastStyle}
                  style={{ marginTop: "0px" }}
                >
                  <div className={Styles.labelStyle}>파일 선택</div>

                  <input
                    className={Styles.inputStyle}
                    disabled
                    style={{ width: "400px" }}
                    value={filePath}
                  />
                  <input
                    type="file"
                    accept=".zip"
                    value={filePath}
                    style={{
                      display: "none"
                    }}
                    // className={Styles.inputStyle}
                    ref={inputFileRef}
                    onChange={e => {
                      setUploadFile(e.target.files);
                      setFilePath(e.target.value);
                    }}
                  />
                  <img
                    src={toAbsoluteUrl("/media/images/btn_people_plus.svg")}
                    alt=""
                    style={{ marginLeft: "4px", marginTop: "2px" }}
                    onClick={() => {
                      if (inputFileRef.current !== null) {
                        inputFileRef.current.click();
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <Dialog
            open={showAsk}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"삭제"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                선택한 항목을 삭제하시겠습니까?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="primary"
                onClick={() => {
                  setShowAsk(false);
                }}
              >
                아니오
              </Button>
              <Button
                color="primary"
                autoFocus
                onClick={() => {
                  setShowAsk(false);
                }}
              >
                예
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={showNew}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{editTitle}</DialogTitle>
            <DialogContent>
              {/* <DialogContentText id="alert-dialog-description">
            선택한 항목을 삭제하시겠습니까?
          </DialogContentText> */}
              <div>
                <div style={{ display: "inline-flex", width: "50px" }}>
                  IP <span style={{ color: "red" }}>&nbsp;&nbsp;*</span>
                </div>
                <input
                  type="text"
                  value={filePath}
                  className={Styles.inputStyle}
                  onChange={e => {
                    console.log("IP", e.target.value);
                    setFilePath(e.target.value);
                  }}
                ></input>
              </div>
              <div style={{ marginTop: "12px" }}>
                <div style={{ display: "inline-flex", width: "50px" }}>
                  비고
                </div>
                <input
                  type="number"
                  value={editDesc}
                  styles={{ width: "60px" }}
                  min={1}
                  max={999}
                  className={Styles.inputStyle}
                  name="phone"
                  onChange={e => {
                    console.log("DESC", e.target.value);
                    setEditDesc(e.target.value);
                  }}
                ></input>
              </div>
            </DialogContent>
            <DialogActions>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  paddingBottom: "8px"
                }}
              >
                <Button
                  className={Styles.buttonSmallStyle}
                  onClick={() => {
                    setShowNew(false);
                  }}
                >
                  취소
                </Button>
                <Button
                  style={{ marginLeft: "24px" }}
                  className={[
                    Styles.buttonSmallStyle,
                    !checkIpAddress() && Styles.buttonDisableStyle
                  ]}
                  autoFocus
                  onClick={() => {
                    setShowNew(false);
                  }}
                >
                  저장
                </Button>
              </div>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </>
  );
}
